import { Component, signal, OnInit } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { AuthService } from 'src/auth/services/auth.service';
import { FormEvents } from 'src/shared/constants';
import { CodeTablesClient, ProfileClient, PersonPhoneDto, PhoneCodeDto } from 'src/shared/services/api.service';

@Component({
  standalone: false,
  selector: 'edportal-educator-contact-phone',
  templateUrl: './educator-contact-phone.component.html',
  styles: ``,
})
export class EducatorContactPhoneComponent implements OnInit {
  addPhoneMode = signal(false);
  selectedPhoneNumber = signal<PersonPhoneDto | undefined>(undefined);
  dataLoaded = signal(false);
  phoneNumbers = signal<PersonPhoneDto[]>([]);
  phoneNumbers$!: Observable<PersonPhoneDto[]>;
  phoneOptions = signal<PhoneCodeDto[]>([]);

  constructor(
    private readonly profileClient: ProfileClient,
    private readonly codeTablesClient: CodeTablesClient,
    public authService: AuthService,
  ) {}

  ngOnInit() {
    this.loadPhoneNumbers();
    this.codeTablesClient.getPersonPhoneCodes().subscribe((x) => this.phoneOptions.set(x));
  }

  loadPhoneNumbers() {
    this.profileClient
      .getPersonsPhoneInfo()
      .pipe(finalize(() => this.dataLoaded.set(true)))
      .subscribe((x) => this.phoneNumbers.set(x));
  }

  enableAddPhone() {
    this.selectedPhoneNumber.set(undefined);
    this.addPhoneMode.set(true);
  }

  handleFormEvent(emissionValue: FormEvents) {
    if (emissionValue == FormEvents.Cancelled) {
      this.selectedPhoneNumber.set(undefined);
      this.addPhoneMode.set(false);
    } else if (emissionValue == FormEvents.Successful) {
      this.selectedPhoneNumber.set(undefined);
      this.addPhoneMode.set(false);
      this.loadPhoneNumbers();
    }
  }

  loadEditForm(phoneNumber: PersonPhoneDto) {
    this.selectedPhoneNumber.set(phoneNumber);
    this.addPhoneMode.set(true);
  }

  phoneNumberItemClasses(phoneNumber: PersonPhoneDto) {
    return {
      editing: phoneNumber.personPhoneNumberId == this.selectedPhoneNumber()?.personPhoneNumberId,
    };
  }
}
